<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="imprimirLaudosLoteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Imprimir Laudos</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="lista_filtrada && lista_filtrada.length">

                            <az-input
                                sizing="sm"
                                icon="fa fa-search"
                                class="mt-3"
                                placeholder="Informar Atendimento..."
                                v-model="pesquisa"
                                @onEnter="selecionar_atendimento()" />

                            <table class="table table-sm table-hover small mt-3 cabecalho-fixo-modal">
                                <thead>
                                    <tr>
                                        <th>
                                            <a href="#" @click.prevent="toggle_selecionados()">
                                                <i class="fa-solid fa-square"></i>
                                            </a>
                                        </th>
                                        <th>
                                            Paciente
                                            <span class="badge badge-secondary ml-2">{{ selecionados.length }}</span>
                                        </th>
                                        <th>#</th>
                                        <th>Procedimento</th>
                                        <th>Material</th>
                                        <th>Solicitante</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista_filtrada" :key="iix" :class="!item.sel ? 'table-secondary' : ''">
                                        <td>
                                            <input type="checkbox" v-model="item.sel" :disabled="!( item.status_laudo && item.status_laudo.fl_pronto )"/> 
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                        </td>
                                        <td>
                                            #{{ item.atendimento_procedimento.id_atendimento }}
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.procedimento.search }}
                                        </td>
                                        <td>
                                            <span v-if="item.atendimento_procedimento.amostra">
                                                {{ item.atendimento_procedimento.amostra.search }}
                                                <template v-if="item.atendimento_procedimento.amostra.js_classes && item.atendimento_procedimento.amostra.js_classes.length == 1">
                                                    <span class="badge badge-success ml-1" v-for="(classe, icx) in item.atendimento_procedimento.amostra.js_classes" :key="icx">
                                                        {{ classe }}
                                                    </span>
                                                </template>
                                            </span>
                                        </td>
                                        <td style="max-width: 100px;">
                                            <div class="text-truncate" v-if="item.atendimento_procedimento.atendimento && item.atendimento_procedimento.atendimento.medico_solicitante">
                                                {{ item.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge" :class="'badge-' + ( item.status_laudo ? item.status_laudo.st_color : 'light' )">
                                                {{ item.status_laudo ? item.status_laudo.search : '?' }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="imprimir_selecionadas()">Imprimir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            tipo_etq: "",
            validate: false, 
            lista: null,
            servidor_impressao: "", 
            pesquisa: "", 
        }       
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    computed: { 
        is_tipo_lamina: function () { 

            if ( this.tipo_etq && this.tipo_etq.search && this.tipo_etq.search.startsWith('Lâmina') ) { 
                return true;
            }

            return false; 

        },

        lista_filtrada: function () { 
            if ( !this.lista ) { 
                return []; 
            }

            return this.lista.filter(item => ( item && item.status_laudo && item.status_laudo.fl_pronto ));
        },

        selecionados: function () {
            if ( !this.lista_filtrada || !this.lista_filtrada.length )
                return [];

            return this.lista_filtrada.filter(item => item.sel);
        },
    },

    methods: { 
        selecionar_atendimento () { 

            let encontrado = false; 

            this.lista_filtrada.forEach(item => {
                if ( this.pesquisa && this.pesquisa.trim().length ) { 
                    if ( item.atendimento_procedimento && item.atendimento_procedimento.id_atendimento == parseInt(this.pesquisa.trim()) ) { 
                        item.sel = true;
                        encontrado = true; 
                    }
                }
            });

            if ( !encontrado ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Atendimento não encontrado na lista: ' + this.pesquisa,
                    life: 3000
                });
            }

            this.pesquisa = null;

            this.$nextTick(() => {
                this.pesquisa = "";
            });

        },

        imprimir_selecionadas () { 
            this.$util.atualizar(this, { 
                service: 'laudos', 
                func: 'imprimir_laudos_lote_ap',
                redir_api: true, 
                dados: { 
                    id_laudos: this.selecionados.map(item => item.id_laudo), 
                },
                modal: 'imprimirLaudosLoteModal',
                toast: true, 
                callback: res => { 
                    if ( res.link && res.link.status_code && res.link.status_code > 400 ) { 
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Erro',
                            detail: 'Não foi possível gerar o arquivo para impressão dos laudos.',
                            life: 5000
                        });
                        return;
                    } else if ( res.link ) { 
                        window.open(res.link, '_blank');
                    }
                }
            });
        },

        toggle_selecionados() {
            let lista = this.lista_filtrada;

            let opcao = lista.find(ld => !ld.sel);

            lista.forEach(ld => {
                ld.sel = opcao;
            });
        },

        abrir (lista) { 
            let nova_lista = _.cloneDeep(lista);

            if ( !nova_lista ) { 
                nova_lista = [];
            } else { 
                nova_lista = nova_lista.filter(item => item.atendimento_procedimento); 
            }

            this.lista = nova_lista; 

            $('#imprimirLaudosLoteModal').modal('show');
        },

    }

}
</script>
